module.exports = __webpack_public_path__ + "static/26-c0d242930c07d9226b962b1f660d30aa.jpg";